'use strict';

var Base = require('./Base');
var Events = require('../Events');
var ListenerInfo = require('../Events/ListenerInfo');
var EventsHandler = require('../Events/EventsHandler');

/**
 * @param formID The ID of the form element.
 * @constructor
 */
var Form = function(formID) { this.initialize(formID); };

jQuery.extend(jQuery.extend(Form.prototype, Base.prototype), {
    form: null,
    iframe: null,
    excludeFromSubmitClass: 'DO_NOT_SUBMIT',
    validationEvents: null,
    validationFailureEvents: null,
    //This is a cache of the event handlers we created so
    //that we can remove them in the cleanup function
    _registeredListeners: null,

    /*
     Public Methods
     */
    initialize: function(formID){
        var listenerInfo;
        var i ;
        this.form = document.getElementById(formID);
        this.form.onsubmit = this.submit.bind(this);
        this._registeredListeners = [];

        var inputs = this.form.getElementsByTagName('input');
        for(i = 0; i < inputs.length; i++){
            if(inputs[i].type.toUpperCase() === 'SUBMIT'){
                listenerInfo = new ListenerInfo(inputs[i], 'click', jQuery.proxy(this.setSubmitButton, inputs[i]));
                this._registeredListeners.push(listenerInfo);
            }
        }

        var submitLinks = this.form.getElementsByClassName('submit');
        for(i = 0; i < submitLinks.length; i++){
            submitLinks[i].ajaxForm = this;
            listenerInfo = new ListenerInfo(submitLinks[i], 'click', jQuery.proxy(this.setSubmitLink, submitLinks[i]), true);
            this._registeredListeners.push(listenerInfo);
        }

        // For file upload, we need to post to an iframe.  This automagically creates on on any form inputs with class 'fileInput'
        if (this.form.getElementsByClassName('fileInput').length > 0) {
            var frameName = 'ajaxFormIframe_' + new Date().getTime();

            var iFrameBox = document.createElement('div');
            iFrameBox.style.width = '0px';
            iFrameBox.style.height = '0px';
            iFrameBox.innerHTML = '<iframe width="0px" height="0px" name="' + frameName + '" id="' + frameName + '"></iframe>';
            document.body.appendChild(iFrameBox);

            this.iframe = document.getElementById(frameName);
            this.form.target = frameName;

            //ie8 and lower, as well as opera 6 and lower don't do iframe.onload correctly, so use this workaround from
            //http://www.nczonline.net/blog/2009/09/15/iframes-onload-and-documentdomain/
            if (this.iframe.attachEvent) {
                this.iframe.attachEvent('onload', this.iframeComplete.bind(this));
            } else {
                this.iframe.onload = this.iframeComplete.bind(this);
            }
        }

        this.initializeEventHandlers();
        this.validationEvents = new EventsHandler();
        this.validationFailureEvents = new EventsHandler();
        this.validationEvents.setBubbleExceptions(true);

        listenerInfo = new ListenerInfo(window, 'unload', this._cleanupForm.bind(this));
        this._registeredListeners.push(listenerInfo);

        Events.registerAll(this._registeredListeners);
    },

    addSubmitEvent: function(func){
        this.submitEvents.addEvent(func);
    },

    // validation events should throw an error if something is wrong
    addValidationEvent: function(func){
        this.validationEvents.addEvent(func);
    },

    addValidationFailureEvent: function(func){
        this.validationFailureEvents.addEvent(func);
    },

    addSuccessEvent: function(func){
        this.successEvents.addEvent(func);
    },

    addCompleteEvent: function(func){
        this.completeEvents.addEvent(func);
    },

    submit: function(fromLink) {
        try {
            this.validationEvents.executeEvents();
        } catch (e) {
            this.validationFailureEvents.executeEvents();
            return;
        }

        this.submitEvents.executeEvents();

        if (this.iframe) {
            if (fromLink) {
                this.form.onsubmit = null;
                //Note: In IE when a file is submitted that does not exist, form.submit() throws an exception
                try {
                    this.form.submit();
                    return false;
                } catch (e) {
                    this.validationFailureEvents.executeEvents();
                    return;
                }
            }
            return true;
        }

        this.addCompleteEvent(function(){
            this.form = null;
        }.bind(this));

        if(!this.getContentContainer()) {
            this.addCompleteEvent(this.cleanupStorage.bind(this));
        }

        var options = {
            type: this.form.method || 'POST',
            data: this.serialize(),
            async: this.asynchronous,
            success: this.successEvents.executeEvents.bind(this.successEvents),
            complete: this.completeEvents.executeEvents.bind(this.completeEvents),
            error:  this.failureEvents.executeEvents.bind(this.failureEvents),
            url: this.form.action,
            dataType: 'html'
        };

        jQuery.ajax(options);
        return false;
    },

    // serialize everything that does not have the exclude class
    serialize: function() {
        return jQuery(this.form).not('.'+this.excludeFromSubmitClass).serialize();
    },

    excludeFromSubmit: function (elementId) {
        jQuery('#' + elementId).addClass(this.excludeFromSubmitClass);
    },

    includeInSubmit: function (elementId) {
        jQuery('#' + elementId).removeClass(this.excludeFromSubmitClass);
    },

    setSubmitButton: function(){
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = this.name;
        input.value = this.value;
        this.form.appendChild(input);
    },

    setSubmitLink: function(e){
        e.stopPropagation();

        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = this.name;
        input.value = this.name;
        this.ajaxForm.form.appendChild(input);
        this.ajaxForm.submit.bind(this.ajaxForm)(true);
    },

    iframeComplete: function() {
        var iframeDocument = this._getIframeDocument();
        if (iframeDocument && iframeDocument.body && iframeDocument.body.childNodes.length > 0) {
            this.getContentContainer().innerHTML = iframeDocument.body.innerHTML;
            jQuery('script').each(function(){
                setTimeout(function(){jQuery.globalEval(this.innerHTML);}, 10);
            });
            this.successEvents.executeEvents();
            this.completeEvents.executeEvents();
        }
    },

    toString: function() {
        return '[MITS.AjaxAPI.Form]: ' + this.form;
    },

    /*
     Overrides: MITS.AjaxAPI.Base
     */
    getContent: function(){
        this.submit();
    },

    _cleanupForm: function() {
        if(this.form) {
            Events.unregisterAll(this._registeredListeners);
            this.validationEvents.clearEvents();
            this.validationFailureEvents.clearEvents();
            this.completeEvents.clearEvents();

            this.form.onsubmit = null;
            this.form = null;
        }
    },

    /*
     Private Methods
     */
    _getIframeDocument: function() {
        var iframeDocument = null;
        if (this.iframe.contentDocument) { // For NS6
            iframeDocument = this.iframe.contentDocument;
        } else if (this.iframe.contentWindow) { // For IE5.5 and IE6
            iframeDocument = this.iframe.contentWindow.document;
        } else if (this.iframe.document) { // For IE5
            iframeDocument = this.iframe.document;
        }
        return iframeDocument;
    }
});

module.exports = Form;


//////////////////
// WEBPACK FOOTER
// ./mits/AjaxAPI/Form.js
// module id = 8
// module chunks = 0